import axios from "axios";
import AuthConfig from "./AuthConfig";
import AuthChallenge from "./Enums/AuthChallenge";

const AWSCognitoIdentityProvider = {
	request: (method, data) => {
		const thisData = {
			ClientId: AuthConfig.clientId,
			UserPoolId: AuthConfig.userPoolId
		};
		return new Promise((resolve, reject) => {
			axios.request({
				url: "https://cognito-idp." + AuthConfig.region + ".amazonaws.com/",
				headers: {
					"X-Amz-Target": "AWSCognitoIdentityProviderService." + method,
					"Content-Type": "application/x-amz-json-1.1"
				},
				mode: "cors",
				cache: "no-cache",
				method: "POST",
				responseType: "json",
				data: JSON.stringify({
					...thisData,
					...data
				})
			}).then((response) => {
				if (response.status !== 200) {
					reject(new Error(response.data.message));
					return;
				}
				resolve({ success: true, data: response.data });
			}).catch((error, response) => {
				reject(new Error(error.response.data.message));
			});
		});
	},
	login: (username, password) => {
		return AWSCognitoIdentityProvider.request("InitiateAuth", {
			AuthFlow: "USER_PASSWORD_AUTH",
			AuthParameters: {
				USERNAME: username,
				PASSWORD: password
			}
		});
	},
	setNewPassword: (username, password, session) => {
		return AWSCognitoIdentityProvider.request("RespondToAuthChallenge", {
			ChallengeName: AuthChallenge.NEW_PASSWORD_REQUIRED,
			ChallengeResponses: {
				USERNAME: username,
				NEW_PASSWORD: password
			},
			Session: session
		});
	},
	getUser: (accessToken) => {
		return AWSCognitoIdentityProvider.request("GetUser", {
			AccessToken: accessToken
		});
	},
	refresh: (refreshToken) => {
		return AWSCognitoIdentityProvider.request("InitiateAuth", {
			AuthFlow: "REFRESH_TOKEN_AUTH",
			AuthParameters: {
				REFRESH_TOKEN: refreshToken
			}
		});
	},
	logout: (accessToken) => {
		return AWSCognitoIdentityProvider.request("GlobalSignOut", {
			AccessToken: accessToken
		});
	}
};
export default AWSCognitoIdentityProvider;
